import React from 'react';
import { Tabs } from 'antd';
import EventsGridContainer from '../containers/EventsGridContainer';
import CommandsGridContainer from '../containers/CommandsGridContainer';
import { withPage } from 'components/Page';

const { TabPane } = Tabs;

const EventViewer = () => {
	return (
		<Tabs defaultActiveKey="events" destroyInactiveTabPane>
			<TabPane tab="Events" key="events">
				<EventsGridContainer />
			</TabPane>
			<TabPane tab="Commands" key="commands">
				<CommandsGridContainer />
			</TabPane>
		</Tabs>
	);
};

EventViewer.displayName = 'EventViewer';

export default withPage(EventViewer);
